export enum RosterPosition {
  Center = "C",
  Forward = "F",
  ForwardCenter = "FC",
  GuardForward = "GF",
  Guard = "G",
  PowerForward = "PF",
  PointGuard = "PG",
  SmallForward = "SF",
  ShootingGuard = "SG",

  CenterBackcourt = "CB",
  DefensiveSpecialist = "D",
  Goalkeeper = "G",
  LeftBackcourt = "LB",
  LeftWingman = "LW",
  Pivot = "P",
  RightBackcourt = "RB",
  RightWingman = "RW",

  Goalie = "G",
  Skater = "S",

  AttackingMidfield = "AM",
  CentreForward = "CF",
  CentreHalf = "CH",
  Defender = "D",
  DefensiveMidfield = "DM",
  FullBack = "FB",
  GoalKeeper = "GK",
  HalfBack = "HB",
  LeftForward = "LF",
  Midfielder = "M",
  Outfielder = "O",
  RightForward = "RF",
  Striker = "S",
  Sweeper = "SW",
}
